import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { Button } from 'primereact/button'
import { getStripeConnectStatusService, startStripeConnectOnboardingService } from '../Service/ReligiousPlaceService'

function PaymentFormComponent({ user_access_key, religious_place_access_key }) {
    const { t } = useTranslation('user_home')
    const [searchParams, setSearchParams] = useSearchParams()
    const [status, setStatus] = useState(null)
    const [loading, setLoading] = useState(true)
    const [starting, setStarting] = useState(false)

    const loadStatus = useCallback(async () => {
        if (!user_access_key || !religious_place_access_key) {
            setLoading(false)
            return
        }
        setLoading(true)
        const res = await getStripeConnectStatusService(user_access_key, religious_place_access_key)
        if (res?.success && res?.data) {
            setStatus(res.data)
        } else {
            setStatus(null)
        }
        setLoading(false)
    }, [user_access_key, religious_place_access_key])

    useEffect(() => {
        loadStatus()
    }, [loadStatus])

    useEffect(() => {
        const stripeParam = searchParams.get('stripe_connect')
        if (stripeParam !== 'return' && stripeParam !== 'refresh') return
        let cancelled = false
        ;(async () => {
            await loadStatus()
            if (!cancelled) {
                setSearchParams((prev) => {
                    const next = new URLSearchParams(prev)
                    next.delete('stripe_connect')
                    return next
                }, { replace: true })
            }
        })()
        return () => { cancelled = true }
    }, [searchParams, setSearchParams, loadStatus])

    const handleStartOnboarding = async () => {
        if (!user_access_key || !religious_place_access_key || starting) return
        setStarting(true)
        const res = await startStripeConnectOnboardingService({
            user_access_key,
            religious_place_access_key
        })
        if (res?.success && res?.data?.url) {
            window.location.href = res.data.url
            return
        }
        setStarting(false)
        alert(t('user_home_stripe_connect_error'))
    }

    if (!user_access_key || !religious_place_access_key) {
        return null
    }

    if (loading) {
        return <div className='text-sm'>{t('user_home_stripe_connect_loading')}</div>
    }

    if (status?.stripe_donations_enabled) {
        return (
            <div className='flex flex-column gap-2'>
                <div className='text-green-600 font-bold'>{t('user_home_stripe_connect_ready')}</div>
                <div className='text-sm text-600'>{t('user_home_stripe_connect_ready_hint')}</div>
            </div>
        )
    }

    return (
        <div className='flex flex-column gap-3'>
            <div className='text-sm text-600'>{t('user_home_stripe_connect_intro')}</div>
            {status?.has_account && !status?.stripe_donations_enabled && (
                <div className='text-sm text-orange-500'>{t('user_home_stripe_connect_incomplete')}</div>
            )}
            <Button
                label={starting ? t('user_home_stripe_connect_redirecting') : t('user_home_stripe_connect_cta')}
                onClick={handleStartOnboarding}
                disabled={starting}
            />
        </div>
    )
}

export default PaymentFormComponent
